  // Commented code to be used when the complete TalkNow page is migrated to Angular


import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
// import { OeAppService } from '../../shared/oe-app.service';
// import { LocationService } from '../../shared/location.service';

@Component({
  selector: 'lp2-contact-us-profile',
  template: `
    <div class="img-container">
      <img [src]="role.image">
      <div class="inner-text-container">
        <span class="inner-text">{{'talkNow.' + role.description | translate}}</span>
      </div>
    </div>
    <div class="page-sub-title">
      <h2>{{'talkNow.' + role.role | translate}}</h2>
    </div>
  `,
  styleUrls: ['./contact-us-profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactUsProfileComponent {
  @Input() role;
  // isWritingFeedbackButtonEnabled: boolean;
  // servicePhone: string;

  // constructor(private oeApp: OeAppService, private locationService: LocationService) { }

  // ngOnInit() {
    //TO-DO: may be oeServicePhone -------------
    // this.isWritingFeedbackButtonEnabled = false;
    // const countryCode = this.oeApp.getCommonData().countryCode;
    // this.locationService.getPhoneWithCountryCode(countryCode).subscribe(countryData => this.servicePhone = countryData.phone.oeContactPhone);
  // }

}



// WEBPACK FOOTER //
// ./ts/app/contact-us/contact-us-profile/contact-us-profile.component.ts